// import history from 'src/lib/history';
import RestClient from '../../config/rest-client';
import processError from '../../lib/error';
import {uniq} from 'lodash'

export function getSliders(where) {
  return async (dispatch) => {
    try {
      dispatch({type: 'SET_SLIDERS_KEY', key: 'isLoaded', data: false})
      let result = [];
      if(where.folder || where.categories || where.subcategories){
        result = await RestClient.get('sliders', '', where);
      }
      
      dispatch({
        type: 'SET_SLIDERS',
        data: result,
      });
    } catch (error) {
      dispatch({type: 'SET_SLIDERS_KEY', key: 'isLoaded', data: true})
      console.log("🚀 ~ file: actions.js:15 ~ return ~ error:", error)
      throw new Error('ss');
      // processError(error, dispatch)
    }
  };
}


export function createSliders(body) {
  return async (dispatch) => {
    try {
      dispatch({type: 'SET_SLIDERS_KEY', key: 'isLoaded', data: false})
      const data = await RestClient.create('sliders', body);
      dispatch({
        type: 'CREATE_SLIDER',
        data: data,
      });
    } catch (error) {
      dispatch({type: 'SET_SLIDERS_KEY', key: 'isLoaded', data: true})
      console.log("🚀 ~ file: actions.js:15 ~ return ~ error:", error)
      throw new Error('ss');
      // processError(error, dispatch)
    }
  };
}

export function createSlidersCopy(body) {
  return async (dispatch) => {
    try {
      dispatch({type: 'SET_SLIDERS_KEY', key: 'isLoaded', data: false})
      const data = await RestClient.create('sliders/copy', body);
      dispatch({
        type: 'CREATE_SLIDER',
        data: data,
      });
    } catch (error) {
      dispatch({type: 'SET_SLIDERS_KEY', key: 'isLoaded', data: true})
      console.log("🚀 ~ file: actions.js:15 ~ return ~ error:", error)
      throw new Error('ss');
      // processError(error, dispatch)
    }
  };
}

export function updateSliders(body) {
  return async (dispatch) => {
    try {
      dispatch({type: 'SET_SLIDERS_KEY', key: 'isLoaded', data: false})
      const data = await RestClient.update('sliders', body.id, body);
      dispatch({
        type: 'UPDATE_SLIDER',
        data: data,
      });
    } catch (error) {
      dispatch({type: 'SET_SLIDERS_KEY', key: 'isLoaded', data: true})
      console.log("🚀 ~ file: actions.js:15 ~ return ~ error:", error)
      throw new Error('ss');
      // processError(error, dispatch)
    }
  };
}

export function deleteSlider(id) {
  return async (dispatch) => {
    try {
      dispatch({type: 'SET_SLIDERS_KEY', key: 'isLoaded', data: false})
      const data = await RestClient.delete('sliders', id);
      dispatch({
        type: 'DELETE_SLIDER',
        data: id,
      });
    } catch (error) {
      dispatch({type: 'SET_SLIDERS_KEY', key: 'isLoaded', data: true})
      console.log("🚀 ~ file: actions.js:15 ~ return ~ error:", error)
      throw new Error('ss');
      // processError(error, dispatch)
    }
  };
}

export function getFolders() {
  return async (dispatch) => {
    try {
      dispatch({type: 'SET_SLIDERS_KEY', key: 'isLoaded', data: false})
      const result = await RestClient.get('slider-folders', '');
      dispatch({
        type: 'SET_SLIDERS_FOLDERS',
        data: result.filter(_i => !_i.parent_id),
        subfolders: result.filter(_i => !!_i.parent_id),
      });
    } catch (error) {
      console.log("🚀 ~ file: actions.js:147 ~ return ~ error:", error)
      dispatch({type: 'SET_SLIDERS_KEY', key: 'isLoaded', data: true})
      throw new Error('ss');
      // processError(error, dispatch)
    }
  };
}


export function createFolder(body) {
  return async (dispatch) => {
    try {
      dispatch({type: 'SET_SLIDERS_KEY', key: 'isLoaded', data: false})
      const result = await RestClient.post('slider-folders', body);
      dispatch({
        type: 'SET_SLIDERS_FOLDER_ADD',
        data: result,
      });
    } catch (error) {
      dispatch({type: 'SET_SLIDERS_KEY', key: 'isLoaded', data: true})
      throw new Error('ss');
      // processError(error, dispatch)
    }
  };
}

export function updateFolder(body) {
  return async (dispatch) => {
    try {
      dispatch({type: 'SET_SLIDERS_KEY', key: 'isLoaded', data: false})
      const result = await RestClient.update('slider-folders', body.id, body);
      dispatch({
        type: 'SET_SLIDERS_FOLDER_UPDATE',
        data: result,
      });
    } catch (error) {
      console.log("🚀 ~ file: actions.js:143 ~ return ~ error:", error)
      dispatch({type: 'SET_SLIDERS_KEY', key: 'isLoaded', data: true})
      throw new Error('ss');
      // processError(error, dispatch)
    }
  };
}

export function deleteFolder(id) {
  return async (dispatch) => {
    try {
      dispatch({type: 'SET_SLIDERS_KEY', key: 'isLoaded', data: false})
      const result = await RestClient.delete('slider-folders', id);
      dispatch({
        type: 'SET_SLIDERS_FOLDER_DELETE',
        data: id,
      });
    } catch (error) {
      console.log("🚀 ~ return ~ error:", error)
      dispatch({type: 'SET_SLIDERS_KEY', key: 'isLoaded', data: true})
      throw new Error('ss');
      // processError(error, dispatch)
    }
  };
}



export function deleteSubfolder(id) {
  return async (dispatch) => {
    try {
      dispatch({type: 'SET_SLIDERS_KEY', key: 'isLoaded', data: false})
      const result = await RestClient.delete('slider-folders', id);
      dispatch({
        type: 'SET_SLIDERS_SUBFOLDER_DELETE',
        data: id,
      });
    } catch (error) {
      console.log("🚀 ~ file: actions.js:202 ~ return ~ error:", error)
      dispatch({type: 'SET_SLIDERS_KEY', key: 'isLoaded', data: true})
      throw new Error('ss');
      // processError(error, dispatch)
    }
  };
}


export function selectFolder(id) {
  return async (dispatch) => {
    try {
      dispatch({
        type: 'SET_SLIDERS_KEY',
        data: id,
        key: 'selectFolder'
      });
      dispatch({
        type: 'SET_SLIDERS_KEY',
        data: null,
        key: 'selectSubfolder'
      });
    } catch (error) {
      throw new Error('ss');
      // processError(error, dispatch)
    }
  };
}


export function selectSubfolder(id) {
  return async (dispatch) => {
    try {
      dispatch({
        type: 'SET_SLIDERS_KEY',
        data: id,
        key: 'selectSubfolder'
      });
      dispatch({
        type: 'SET_SLIDERS_KEY',
        data: null,
        key: 'selectFolder'
      });
    } catch (error) {
      throw new Error('ss');
      // processError(error, dispatch)
    }
  };
}

export function onCheckFolders(ids) {
  return async (dispatch) => {
    try {
      dispatch({
        type: 'SET_SLIDERS_KEY',
        data: uniq(ids),
        key: 'checkFolders'
      });
     
    } catch (error) {
      throw new Error('ss');
      // processError(error, dispatch)
    }
  };
}


export function onCheckSubfolders(ids) {
  return async (dispatch) => {
    try {
      dispatch({
        type: 'SET_SLIDERS_KEY',
        data: uniq(ids),
        key: 'checkSubfolders'
      });
     
    } catch (error) {
      throw new Error('ss');
      // processError(error, dispatch)
    }
  };
}

export function onCheckCategories(ids) {
  return async (dispatch) => {
    try {
      dispatch({
        type: 'SET_SLIDERS_KEY',
        data: uniq(ids),
        key: 'checkCategories'
      });
     
    } catch (error) {
      throw new Error('ss');
      // processError(error, dispatch)
    }
  };
}


export function onCheckSubcategories(ids) {
  return async (dispatch) => {
    try {
      dispatch({
        type: 'SET_SLIDERS_KEY',
        data: uniq(ids),
        key: 'checkSubcategories'
      });
     
    } catch (error) {
      throw new Error('ss');
      // processError(error, dispatch)
    }
  };
}